import { Grid } from '@material-ui/core'
import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'
import styled, { css } from 'styled-components'

export const TitleArea = styled.div`
  padding-bottom: 20px;
  color: ${colors.green};
  font-weight: bold;
  font-style: italic;
`

export const ContainerItem = styled.div`
  display: flex;
  padding: 15px;

  height: 102px;

  align-items: center;
`

export const GridContainer = styled(Grid)`
  height: 61px;
`

export const ContainerModal = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  padding: 10px;
`
export const Icon = styled.img`
  width: 70px;
  height: 70px;
`

export const TextModal = styled.p`
  font-weight: 700;
  font-size: 24px;
  color: ${colors.blue};
  text-align: center;
`

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${colors.blue};
  padding-bottom: 40px;
`

export const Label = styled.h3`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.gray7};
  padding-bottom: 8px;
`

export const Text = styled.p`
  font-size: 14px;
  font-weight: 600;
  overflow-wrap: anywhere;
`

export const IconDocumento = styled.img`
  src: ${props => props.src};
  width: 100px;
  height: 100px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 32px;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 0px;
  padding-right: 16px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 8px;
`

interface IStatusProps {
  status: string
}
export const Status = styled.div<IStatusProps>`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin-right: 4px;

  ${props =>
    props.status === 'Pago' &&
    css`
      background-color: ${colors.green};
    `}

  ${props =>
    props.status === 'Pendente' &&
    css`
      background-color: ${colors.blueLight};
    `}

  ${props =>
    props.status === 'Vencido' &&
    css`
      background-color: ${colors.red};
    `}
`
export const IconButtonStyle = styled(Button)`
  color: ${colors.blue};
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
  cursor: pointer;
`

export const ContainerInfo = styled.div`
  border-radius: 8px;
  border: 1px solid ${colors.grayLight4};
  padding: 16px;
  display: flex;
  flex-direction: row;
  padding-top: 24px;
`

export const Info = styled.p`
  font-size: 14px;
  font-weight: 400;
  padding-left: 8px;
`
